import AccountSettingsItem from './styled';

export default AccountSettingsItem;
